import { db } from '.';

const systemSettingsRef = db.collection('settings').doc('system');

async function getSettingFromDB(id) {
  const snapshot = await systemSettingsRef.get();
  if (snapshot.exists) {
    const { initialClassId, initialConceptId, ...data } = snapshot.data();
    const finalData = {
      id,
      latestBlog: {},
      ...data,
      initialClass: {},
      initialConcept: {}
    };
    if (initialClassId) {
      const initialClassSnapshot = await db
        .collection('challenges')
        .doc(initialClassId)
        .get();

      finalData['initialClass'] = {
        name: initialClassSnapshot.get('name'),
        id: initialClassSnapshot.id
      };
    }
    if (initialConceptId) {
      const initialConceptSnapshot = await db
        .collection('concepts')
        .doc(initialConceptId)
        .get();

      finalData['initialConcept'] = {
        name: initialConceptSnapshot.get('name'),
        id: initialConceptSnapshot.id
      };
    }
    return finalData;
  } else {
    throw new Error('Settings not found!');
  }
}

async function updateSettingInDB(data) {
  const { id, initialClass, initialConcept, ...docData } = data;
  const initialClassId = initialClass.id || '';
  const initialConceptId = initialConcept.id || '';
  await systemSettingsRef.update({
    ...docData,
    initialClassId,
    initialConceptId
  });
}

export default {
  get: getSettingFromDB,
  update: updateSettingInDB
};
